import { Pagination } from "react-admin";

export const CustomPagination = () => (
  <Pagination rowsPerPageOptions={[5, 10, 20, 30, 50, 100]} />
);
